import ManageTablesButton from "./ManageTablesButton";
import { useTranslation } from "react-i18next";
import ServiceFees from "./ServiceFees";

type TablesPageHeaderProps = {
  setNeedRefetch: React.Dispatch<React.SetStateAction<boolean>>
  branchId?: string;
};

function TablesPageHeader({ setNeedRefetch, branchId }: TablesPageHeaderProps) {
  const { t } = useTranslation();

  return (
    <div className="flex flex-wrap items-center justify-between gap-2 gap-y-2 sm:gap-y-4">
      {/* Head of page */}
      <h2 className="col-span-2 py-1 text-2xl capitalize md:col-span-3 md:text-[40px]">
        {t("TablesPageHeader.title")}
      </h2>

      <div className="flex items-center gap-2">
        <ServiceFees branchId={branchId} />
        <ManageTablesButton setNeedRefetch={setNeedRefetch} />
      </div>
    </div>
  );
}

export default TablesPageHeader;
